import { type RefObject, useRef } from "react";

import { cn } from "@btnet/utilities-core";

import { BuiText } from "../BuiText/BuiText";
import "./BuiLabel.less";
import type { BuiLabelProps } from "./BuiLabel.types";

/**
 * Blueprint label primitive. Prefer `BTLabel` from `@btnet/core-components` in app code.
 */
export function BuiLabel({
  id,
  testid,
  align,
  outerRef,
  text,
  className,
  ariaLabel,
  isRequired,
  size,
  style,
  children,
  htmlFor,
  labelAfter,
  infoContent,
}: BuiLabelProps) {
  const resolvedText = text ?? "";
  const outerR = useRef<HTMLLabelElement>(null);
  const resolvedOuterRef = outerRef ?? outerR;

  const adjustedSize = size ?? (labelAfter ? "normal-md" : "distinct-sm");

  let resolvedAlign = align;
  if (!children && !resolvedAlign) {
    resolvedAlign = "top";
  } else if (!resolvedAlign) {
    resolvedAlign = "left";
  }

  const label = (
    <div className={cn(resolvedText && "bui-label--content")}>
      <BuiText
        className="bui-label--text"
        text={resolvedText}
        tag="span"
        size={adjustedSize}
      />
      {infoContent}
    </div>
  );

  return (
    <label
      id={id ?? htmlFor}
      data-testid={testid}
      ref={resolvedOuterRef as RefObject<HTMLLabelElement>}
      htmlFor={htmlFor}
      className={cn("bui-label", className, {
        "bui-label--row": resolvedAlign === "left" && !labelAfter,
        "bui-label--col": resolvedAlign === "top" && children,
        "bui-label-required": isRequired,
      })}
      aria-label={ariaLabel}
      style={style}
    >
      {!labelAfter && label}
      {children}
      {labelAfter && label}
    </label>
  );
}
